import {
  Component,
  EventEmitter,
  OnInit,
  Output,
} from "@angular/core";
import { ModalController, PickerController, PopoverController } from "@ionic/angular";
import * as moment from "moment";
import { CalendarioComponent } from "src/app/modal-components/calendario/calendario.component";
@Component({
  selector: "date-filter",
  templateUrl: "./date-filter.component.html",
  styleUrls: ["./date-filter.component.scss"],
})
export class DateFilterComponent implements OnInit {
  @Output() filter = new EventEmitter();
  dtInicio: typeof moment;
  dtFim: typeof moment;
  time: "dtInicio" | "dtFinal";
  min: string;
  max: string;

  constructor(
    private modalCtrl: ModalController,
    private pickerCtrl: PickerController,
    private popoverController: PopoverController
  ) { }

  ngOnInit() { }

  async openCalendar(ev, field) {
    this.time = field;

    this.max =
      field === "dtInicio" && this.dtFim
        ? moment(this.dtFim.toString(), 'DD-MM-YYYY').format("YYYY-MM-DD")
        : undefined;
    if (this.dtInicio) {
      console.log(this.dtInicio.toString());
    }
    this.min =
      field === "dtFim" && this.dtInicio
        ? moment(this.dtInicio.toString(), 'DD-MM-YYYY').format("YYYY-MM-DD")
        : undefined;

    const popover = await this.popoverController.create({
      component: CalendarioComponent,
      cssClass: 'popover-seletor-calendario',
      event: ev,
      translucent: false,
      showBackdrop: false,
      componentProps: {
        data: this.max,
        dataMin: this.min,
      }
    });
    await popover.present();
    const data = await popover.onDidDismiss();
    if (data.data) {
      this[this.time] = data.data.format("DD/MM/YYYY");
      this.send();
    }
  }

  pickDate(date?: string) {
    this[this.time] = moment(date).format("DD/MM/YYYY");

    this.send();
  }
  send() {
    this.filter.emit({ dtInicio: this.dtInicio, dtFim: this.dtFim });
  }

  limparFiltro(field: "dtInicio" | "dtFim") {
    this[field] = null;

    this.send();
  }
}
